import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Card } from '@/components/ui/card';
import { useUploadStore } from '@/stores/useUploadStore';
import { FileUploadStep } from './FileUploadStep';
import { MappingStep } from './MappingStep';
import { ValidationStep } from './ValidationStep';
import { CreatePortfolioStep } from './CreatePortfolioStep';
import { WizardProgress } from './WizardProgress';

const steps = [
  { id: 0, title: 'Upload File', description: 'Select your CSV or Excel file' },
  { id: 1, title: 'Map Columns', description: 'Match fields to portfolio data' },
  { id: 2, title: 'Validate', description: 'Review and fix errors' },
  { id: 3, title: 'Create Portfolio', description: 'Name and finalize' },
];

export function UploadWizard() {
  const [currentStep, setCurrentStep] = useState(0);
  const { reset } = useUploadStore();

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleReset = () => {
    reset();
    setCurrentStep(0);
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <FileUploadStep onNext={handleNext} />;
      case 1:
        return <MappingStep onNext={handleNext} onBack={handleBack} />;
      case 2:
        return <ValidationStep onNext={handleNext} onBack={handleBack} />;
      case 3:
        return <CreatePortfolioStep onReset={handleReset} />;
      default:
        return null;
    }
  };

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <WizardProgress steps={steps} currentStep={currentStep} />

      <Card className="p-6">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentStep}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
          >
            {renderStep()}
          </motion.div>
        </AnimatePresence>
      </Card>
    </div>
  );
}
